import { render, staticRenderFns } from "./MomentOwnedListComponent.vue?vue&type=template&id=fd2464e4&scoped=true&"
import script from "./MomentOwnedListComponent.vue?vue&type=script&lang=ts&"
export * from "./MomentOwnedListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MomentOwnedListComponent.vue?vue&type=style&index=0&id=fd2464e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2464e4",
  null
  
)

export default component.exports